module.exports = __webpack_public_path__ + "static/img/container_bg.e7cfcc62.png";